import { level50, level80 } from "../../other/theme/opacities";
import styled from "@emotion/styled";

export interface ITab {
    title: string;
    href: string;
    testId: string;
    isSelected: boolean;
}

export const Tabs = (props: { tabs: ITab[]; testId: string }) => {
    return (
        <TabContainer data-testid={props.testId}>
            {props.tabs.map((x, i) => (
                <Tab
                    key={i}
                    isSelected={x.isSelected}
                    data-testid={x.testId}
                    href={x.href}
                >
                    <VisibleText>{x.title}</VisibleText>
                    <TextForWidth>{x.title}</TextForWidth>
                </Tab>
            ))}
        </TabContainer>
    );
};

const TabContainer = styled("div")({
    display: "flex",
    flexDirection: "row"
});
const Tab = styled("a")<{ isSelected: boolean }>(props => ({
    cursor: "pointer",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    marginRight: 1,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 3,
    paddingTop: 5,
    fontSize: props.theme.fontSizes.small,
    borderBottom: props.isSelected
        ? `solid 2px ${props.theme.brandKey}`
        : `solid 2px ${props.theme.brandForeground + level50}`,
    fontWeight: props.isSelected ? "bold" : "normal",
    color: props.theme.brandForeground + (props.isSelected ? "" : level80),
    "&:hover": {
        color: props.theme.brandForeground,
        borderBottom: props.isSelected
            ? undefined
            : `solid 2px ${props.theme.brandForeground + level80}`
    }
}));
const VisibleText = styled("div")({
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 3,
    textAlign: "center"
});
const TextForWidth = styled("div")({
    visibility: "hidden",
    fontWeight: "bold"
});
